export default {
  items: [
    {
      name: "Trang chủ công ty",
      nameRoute: 'Admin-Home',
      url: "/admin/home",
      icon: "isax-category-2",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["FT1401"]
      }
    },
    // {
    //   name: "Trang chủ cá nhân",
    //   url: "/admin/employee/home",
    //   nameRoute: 'Admin-Home-Employee',
    //   icon: "isax-category-2",
    //   meta: {
    //     allowAccess: ["*"],
    //     page: "admin",
    //     code: ["FT1402"]
    //   }
    // },
    {
      name: "Bảng công công ty",
      url: "/admin/Timekeeping/Worksheet",
      nameRoute: 'Admin-Timekeeping-Worksheet',
      icon: "isax-calendar-1",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["FT801"]
      }
    },
    {
      name: "Bảng công cá nhân",
      url: "/admin/Timekeeping/Employee/EmployeeWorksheet",
      nameRoute: 'Admin-Timekeeping-Employee-EmployeeWorksheet',
      icon: "isax-calendar-1",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["FT901"]
      }
    },
    {
      name: "Chấm công",
      url: "/admin/Timekeeping",
      icon: "isax-emoji-happy",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["FT301", "FT401", "FT701", "FT1901"]
      },
      children: [
        {
          name: "Kết nối Agent",
          url: "/admin/Timekeeping/TimekeepingConfig/AgentConnection",
          nameRoute: 'Admin-Timekeeping-TimekeepingConfig-AgentConnection',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT301"]
          }
        },
        {
          name: "Ngày nghỉ",
          url: "/admin/Timekeeping/TimekeepingConfig/DayOffList",
          nameRoute: 'Admin-Timekeeping-TimekeepingConfig-DayOff-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT401"]
          }
        },
        {
          name: "Ca làm việc",
          url: "/admin/Timekeeping/TimekeepingConfig/Shift/list",
          nameRoute: 'Admin-Timekeeping-TimekeepingConfig-Shift-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT701"]
          }
        },
        {
          name: "Dữ liệu chấm công",
          url: "/admin/Timekeeping/TimekeepingConfig/EntryAndExitHistoryCompanyList",
          nameRoute: 'Admin-Timekeeping-TimekeepingConfig-EntryAndExitHistoryCompanyList',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1901"]
          }
        }
      ]
    },
    {
      name: "Yêu cầu",
      url: "/admin/ManageRequests",
      icon: "isax-messages",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["*"]
      },
      children: [
        {
          name: "Danh sách yêu cầu",
          url: "/admin/ManageRequests/RequestsWaitingForApproval",
          nameRoute: 'Admin-ManageRequests-RequestsWaitingForApproval',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["*"]
          }
        },
        {
          name: "Xin nghỉ",
          url: "/admin/ManageRequests/ListRequests/DayOffRequests",
          nameRoute: 'Admin-ManageRequests-ListRequests-DayOffRequests',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1004"]
          }
        },
        {
          name: "Giải trình công",
          url: "/admin/ManageRequests/ListRequests/WorkAdditionRequests",
          nameRoute: 'Admin-ManageRequests-ListRequests-WorkAdditionRequests',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1004"]
          }
        },
        {
          name: "Đi muộn",
          url: "/admin/ManageRequests/ListRequests/GoLateRequests",
          nameRoute: 'Admin-ManageRequests-ListRequests-GoLateRequests',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1004"]
          }
        },
        {
          name: "Về sớm",
          url: "/admin/ManageRequests/ListRequests/GoHomeEarlyRequests",
          nameRoute: 'Admin-ManageRequests-ListRequests-GoHomeEarlyRequests',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1004"]
          }
        },
        {
          name: "Ra ngoài",
          url: "/admin/ManageRequests/ListRequests/GoOutRequests",
          nameRoute: 'Admin-ManageRequests-ListRequests-GoOutRequests',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1004"]
          }
        },
        {
          name: "Công tác",
          url: "/admin/ManageRequests/ListRequests/GoOnBussinessRequests",
          nameRoute: 'Admin-ManageRequests-ListRequests-GoOnBussinessRequests',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1004"]
          }
        },
        {
          name: "Chấm công online",
          url:
            "/admin/ManageRequests/ListRequests/TimeKeepingOnlineRequests",
          nameRoute: 'Admin-ManageRequests-ListRequests-TimeKeepingOnlineRequests',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1004"]
          }
        },
        {
          name: "Làm thêm giờ",
          url:
            "/admin/ManageRequests/ListRequests/OTRequests",
          nameRoute: 'Admin-ManageRequests-ListRequests-OTRequests',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1004"]
          }
        },
      ]
    },
    {
      name: "Đăng ký cơm trưa",
      url: "/admin/lunch-registration",
      nameRoute: 'Admin-LunchRegistration',
      icon: "isax-coffee",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["*"]
      }
    },
    {
      name: "Nhân sự",
      url: "/admin/EmployeeManager/list",
      nameRoute: 'Admin-EmployeeManager-list',
      icon: "isax-profile-2user",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["FT101"]
      }
    },
    {
      name: "Tiền lương công ty",
      url: "/admin/Salary/SalaryPeriod/SalaryPeriodList",
      nameRoute: 'Admin-Salary-SalaryPeriod-SalaryPeriodList',
      icon: "isax-empty-wallet",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["FT1101"]
      },
      children: [
        {
          name: "Danh sách kỳ lương",
          url: "/admin/Salary/SalaryPeriod/SalaryPeriodList",
          nameRoute: 'Admin-Salary-SalaryPeriod-SalaryPeriodList',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1101"]
          }
        },
        {
          name: "Bảng lương công ty",
          url: "/admin/Salary/SalaryCompany/SalaryCompany",
          nameRoute: 'Admin-Salary-SalaryCompany-SalaryCompany',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1101"]
          }
        },
        {
          name: "Cấu hình tính lương",
          url: "/admin/Salary/SalaryConfig/SalaryConfig",
          nameRoute: 'Admin-Salary-SalaryConfig-SalaryConfig',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1101"]
          }
        }
      ]
    },
    {
      name: "Tiền lương cá nhân",
      url: "/admin/SalaryEmployee/list",
      nameRoute: 'Admin-SalaryEmployee-list',
      icon: "isax-empty-wallet",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["FT1201"]
      }
    },
    // {
    //   name: "Tuyển dụng",
    //   url: "/admin/developing-page",
    //   icon: "isax-tag-user",
    //   meta: {
    //     allowAccess: ["Customer"],
    //     page: "admin",
    //     code: ["FT1201"]
    //   }
    // },
    {
      name: "Thiết lập",
      url: "/admin/settings/electronic-contract-templates",
      icon: "isax-setting-2",
      dropdownClass: "nav-dropdown-items--system-settings",
      meta: {
        allowAccess: ["Customer"],
        page: "admin",
        code: ["FT501", "FT601", "FT1303", "FT407", "FT406", "FT901", "FT902", "FT1001", "FT1003", "FT1004", "FT1006", "FT1007"]
      },
      children: [
        {
          name: "Công ty thành viên",
          url: "/admin/System/Company/list",
          nameRoute: "Admin-Company-list",
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT001", "FT002", "FT003", "FT004", "FT2302", "FT2303", "FT2304", "FT2305", "FT2306"]
          }
        },
        {
          name: "Chi nhánh",
          url: "/admin/System/Branch/list",
          nameRoute: 'Admin-Branch-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Phòng ban",
          url: "/admin/System/Department/list",
          nameRoute: 'Admin-Department-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Chức vụ",
          url: "/admin/System/Position/list",
          nameRoute: 'Admin-Position-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Trợ cấp",
          url: "/admin/System/SubsidiesSalaryType/list",
          nameRoute: 'Admin-SubsidiesSalaryType-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Hệ số lương",
          url: "/admin/System/CoefficientSalary/list",
          nameRoute: 'Admin-CoefficientSalary-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Loại hợp đồng",
          url: "/admin/System/ContractType/list",
          nameRoute: 'Admin-ContractType-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Chuyên ngành",
          url: "/admin/System/Major/list",
          nameRoute: 'Admin-Major-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Trình độ",
          url: "/admin/System/Qualification/list",
          nameRoute: 'Admin-Qualification-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Bậc lương",
          url: "/admin/System/RankSalary/list",
          nameRoute: 'Admin-RankSalary-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Quan hệ",
          url: "/admin/System/Relationship/list",
          nameRoute: 'Admin-Relationship-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Lý do",
          url: "/admin/System/RequestReason/list",
          nameRoute: 'Admin-RequestReason-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT601"]
          }
        },
        {
          name: "Ngày nghỉ",
          url: "/admin/System/DayOffCommon/list",
          nameRoute: 'Admin-DayOffCommon-list',
          icon: "none",
          meta: {
            allowAccess: ["AdminSystem"],
            page: "admin",
            code: ["FT407"]
          }
        },
        {
          name: "Quyền",
          url: "/admin/System/Role/list",
          nameRoute: 'Admin-Role-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1301"]
          }
        },
        {
          name: "Tài sản",
          url: "/admin/System/Asset/list",
          nameRoute: 'Admin-Asset-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1601"]
          }
        },
        {
          name: "Hợp đồng/Văn bản",
          url: "/admin/System/Contract-Document/list",
          nameRoute: 'Admin-Contract-Document-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT2101"]
          }
        },
        {
          name: "Cấu hình mẫu hợp đồng",
          url: "/admin/settings/electronic-contract-templates",
          nameRoute: "Admin-Settings-ElectronicContractTemplate-list",
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["*"],
          }
        },
        {
          name: "Cấu hình mẫu văn bản",
          url: "/admin/settings/electronic-document-templates",
          nameRoute: "Admin-Settings-ElectronicDocumentTemplate-list",
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["*"],
          }
        },
        {
          name: "Con dấu tổ chức",
          url: "/admin/organization-seal",
          nameRoute: 'Admin-OrganizationSeal',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1804"]
          }
        },
        {
          name: "Phân quyền",
          url: "/admin/RoleFeature/list",
          nameRoute: 'Admin-RoleFeature-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1303"]
          }
        },
        {
          name: "Nghỉ phép",
          url: "/admin/EmployeeDayOffConfig",
          nameRoute: 'Admin-EmployeeDayOffConfig-List',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT406"]
          }
        },
        {
          name: "Loại công việc",
          url: "/admin/System/TaskType/list",
          nameRoute: 'Admin-TaskType-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT501"]
          }
        },
        {
          name: "Lịch sử chỉnh sửa bảng công",
          url: "/admin/Timekeeping/TimekeepingConfig/WorkChangeHistory/list",
          nameRoute: 'Admin-Timekeeping-TimekeepingConfig-WorkChangeHistory-list',
          icon: "none",
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT901", "FT902", "FT1001", "FT1003", "FT1004", "FT1006", "FT1007"]
          }
        },
      ]
    }
  ]
};
